module.exports = __webpack_public_path__ + "c2996b7dccb933362a15534f7efea8dd.png";